import React, { useState, useEffect } from "react";
import CryptoJS from "crypto-js";
import ReactGA from "react-ga4";
import { useLanguage } from "../context/LanguageContext";

function ItensComprados({ produtos, pagamento }) {
  const { t } = useLanguage();
  const [imagensDescriptografadas, setImagensDescriptografadas] = useState([]);

  useEffect(() => {
    if (localStorage.getItem("adminImpersonation")) return;
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: "Baixando imagens compradas",
    });
  }, []);

  useEffect(() => {
    if (!produtos || !pagamento) return;

    const processarImagens = async () => {
      const imagens = produtos.map((produto) => {
        if (pagamento === "Pago") {
          const enc = produto?.image;
          if (enc) {
            const dec = descriptografarImagem(enc);
            // Se a descriptografia foi bem-sucedida, usar a imagem descriptografada
            // Caso contrário, usar imageSample como fallback
            return dec !== null ? dec : (produto?.imageSample || "");
          }
          return produto?.imageSample || "";
        }
        return produto?.imageSample || "";
      });

      setImagensDescriptografadas(imagens);
    };

    processarImagens();
  }, [produtos, pagamento]);

  const descriptografarImagem = (imagemCriptografada) => {
    try {
      const secret = import.meta.env.VITE_REACT_APP_BACKEND_JWT_SECRET;
      
      if (!imagemCriptografada || !secret) {
        console.warn("Imagem ou chave secreta ausente para descriptografia");
        return null;
      }

      const bytes = CryptoJS.AES.decrypt(imagemCriptografada, secret);
      const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
      
      // Verificar se a descriptografia foi bem-sucedida
      if (!decryptedText) {
        console.warn("Falha na descriptografia - resultado vazio");
        return null;
      }

      return decryptedText;
    } catch (error) {
      console.error("Erro ao descriptografar imagem:", error);
      return null;
    }
  };

  const baixarImagem = (urlImagem, index) => {
    if (!urlImagem) {
      console.warn("URL da imagem não disponível para download");
      return;
    }
    
    // Para pagamentos aprovados, usar sempre a imagem descriptografada
    const imagemParaDownload = pagamento === "Pago" 
      ? imagensDescriptografadas[index] 
      : urlImagem;
    
    if (!imagemParaDownload) {
      console.warn("Imagem não disponível para download");
      return;
    }
    
    window.open(imagemParaDownload, "_blank", "noopener,noreferrer");
  };

  if (!produtos || !pagamento) {
    return (
      <div className="text-center py-4">
        <p>{t("payment.loadingItems")}</p>
        <p className="text-sm opacity-70">{t("payment.reloadHint")}</p>
      </div>
    );
  }

  return (
    <div className="px-4 py-8 max-w-7xl mx-auto">
      <div className="overflow-x-auto">
        <h2 className="text-xl text-center mb-4">{t("payment.itemsPurchasedTitle")}</h2>

        <table className="table">
          <tbody>
            {produtos.map((produto, index) => (
              <tr key={produto._id} className="bg-base-100 hover:bg-base-300">
                <td>
                  <div className="avatar w-40 h-28 ">
                    <img
                      src={
                        pagamento === "Pago"
                          ? (imagensDescriptografadas[index] || produto.imageSample)
                          : produto.imageSample
                      }
                      alt={produto.nome || `Produto ${index + 1}`}
                      onError={(e) => {
                        // Fallback para imageSample se a imagem descriptografada falhar
                        if (e.target.src !== produto.imageSample) {
                          e.target.src = produto.imageSample;
                        }
                      }}
                    />
                  </div>
                </td>
                <td className="align-middle">
                  <button
                    className={`bg-blue-500 text-white p-2 rounded  ${
                      pagamento !== "Pago"
                        ? "opacity-50 cursor-not-allowed"
                        : ""
                    }`}
                    onClick={() =>
                      pagamento === "Pago" &&
                      baixarImagem(imagensDescriptografadas[index], index)
                    }
                    disabled={pagamento !== "Pago"}
                  >
                    Download
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ItensComprados;
